/**
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/12/7
 */
import React from 'react';

const Recover = () => {
  return <svg className="store-svg-recover" viewBox="0 0 1024 1024">
    <path d="M512 34.133c263.509 0 477.867 214.357 477.867 477.867s-214.357 477.867-477.867 477.867-477.867-214.357-477.867-477.867 214.357-477.867 477.867-477.867M512 6.827c-278.528 0-505.173 226.645-505.173 505.173s226.645 505.173 505.173 505.173 505.173-226.645 505.173-505.173-226.645-505.173-505.173-505.173v0z"/>
    <path d="M845.141 458.752l-15.019-13.653-34.133 39.595c-16.384-148.821-140.629-259.413-289.451-259.413-125.611 0-237.568 77.824-277.163 197.973l20.48 6.827c36.864-111.957 140.629-184.32 258.048-184.32 141.995 0 258.048 105.131 270.336 249.856l-50.517-42.325-13.653 15.019 72.363 60.075 58.709-69.632z"/>
    <path d="M517.461 778.24c-143.36 0-260.779-111.957-270.336-249.856l50.517 42.325 13.653-15.019-72.363-62.805-60.075 72.363 15.019 13.653 32.768-39.595c15.019 143.36 139.264 259.413 289.451 259.413 125.611 0 237.568-81.92 277.163-200.704l-20.48-6.827c-34.133 110.592-139.264 187.051-255.317 187.051z"/>
    <path d="M517.461 585.728h-68.267v-19.115h68.267v-39.595h-68.267v-19.115h54.613l-75.093-118.784h19.115c0 0 68.267 99.669 79.189 117.419v0c12.288-19.115 79.189-117.419 79.189-117.419h19.115l-73.728 117.419h54.613v19.115h-68.267v40.96h68.267v19.115h-68.267v49.152h-19.115v-49.152z"/>
  </svg>
};

export default Recover;



// WEBPACK FOOTER //
// ./src/svgs/recover.js